/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function ($) {
  "use strict";
  // javascript code here. i.e.: $(document).ready( function(){} );
  //Burger menu
  function burgerMenu() {
    $(document).ready(function() {
      $(".ham-burger").on('click', function (e) {
        e.preventDefault();
        $(".site-header-menu").toggleClass("nav-active");
        $('body').toggleClass("disable");
        console.log($('body'))
      });
      $(".menu-item-has-children ul").before('<span class="arrow">arrow</span>');
    });
  }

  burgerMenu();

  $(".arrow").click(function () {
    $(this).next("ul").slideToggle('slow');
    $(this).next(".navbar-nav").slideToggle('slow');
    $(this).parent("li").toggleClass("submenu-active");
  });

})(jQuery);

document.addEventListener("DOMContentLoaded", function() {
  // Get all elements with the class "dropdown-menu"
  var targetElements = document.getElementsByClassName("dropdown-menu");

  // Iterate through the elements
  for (var i = 0; i < targetElements.length; i++) {
    // Get the parent element
    targetElements[i].classList.add("sub-menu");
    var parentElement = targetElements[i].parentElement;

    // Check if the parent element exists before adding the class
    if (parentElement) {
      parentElement.classList.add("menu-item-has-children");
    }
  }
});
